import type { ManualJournal, XeroImportConfirmation } from '../types';

/**
 * B2 (docs/core-workflow.md): where a journal stands on its way into Xero. "Exported" means a file was produced; it is
 * never "in Xero" until someone who can see Xero confirms it. A withdrawn confirmation is kept and no longer counts.
 */
export type XeroImportState = 'draft' | 'unconfirmed' | 'confirmed';

export function activeXeroConfirmation(journal: ManualJournal): XeroImportConfirmation | null {
  const list = journal.xeroImportConfirmations ?? [];
  for (let i = list.length - 1; i >= 0; i--) if (!list[i].withdrawnAt) return list[i];
  return null;
}

export function xeroImportState(journal: ManualJournal): XeroImportState {
  if (journal.status !== 'exported') return 'draft';
  return activeXeroConfirmation(journal) ? 'confirmed' : 'unconfirmed';
}

/**
 * The reference every export stamps into its narration (server: `XeroReferences.For`). Derived here too, because the
 * page knows the journal's id the moment the export returns, before any refetch. Both suites pin the same example.
 */
export function xeroReferenceFor(journalId: string): string {
  return `CNV-${journalId.replace(/[^0-9a-z]/gi, '').slice(0, 8).toUpperCase()}`;
}
